import { gql } from "@apollo/client/core";

export default gql`
    fragment DisasterCategory on DisasterCategory {
        id
        title
        description
    }
`
